/**
 * THE EXPERIENCES THIS WIDGET CAN WEAR, by key. MP's Themes.Theme_Key names
 * one (docs/event-experiences.md). A key MP names that is not here is the
 * default page; an experience here that no theme names is reachable only
 * through the staff time machine (?xp=<key>), which is how next year's is
 * built while this year's is live.
 */
import { CHROME as WHAT_MATTERS_CHROME } from './what-matters-2026/chrome';
import { lazy } from 'react';
import WhatMattersSkeleton from './what-matters-2026/Skeleton';
import type { Experience } from './types';

export const EXPERIENCES: Record<string, Experience> = {
  'what-matters-2026': {
    Page: lazy(() => import('./what-matters-2026')),
    // The microsite's own time-machine moments (lib/mode.ts): the live day
    // lands in Breakout Session One, the recap three days after.
    moments: {
      before: '2026-10-20T12:00:00',
      live: '2026-11-07T10:52:00',
      recap: '2026-11-10T12:00:00',
      teaser: '2028-02-12T12:00:00',
    },
    // HARDCODED: the 2028 conference's announcement date (microsite
    // what-matters.ts nextEdition.teaserFrom). Move to the next event's
    // Themes row when it exists.
    teaserFrom: '2028-02-01T00:00:00',
    // Garden Paper on the site's own chrome: cream type and a marigold Give
    // over the sage hero, and the footer on the hero's deepest sage.
    chrome: WHAT_MATTERS_CHROME,
    Skeleton: WhatMattersSkeleton,
    // HARDCODED, a hint only: shows this skeleton before the event loads.
    // MP's Themes.Theme_Key still decides once it has. Other events learn it
    // from a first visit (experienceHint below).
    matches: { eventIds: [329668], slugs: ['womens-conference'] },
  },
};

export const EXPERIENCE_KEYS = Object.keys(EXPERIENCES);

const HINT_KEY = 'ed-xp-hint:';

/**
 * Which experience this page will probably wear, before the event loads, so
 * the skeleton is the experience's rather than the stock one. The registry's
 * own matches first, then what this device saw last time.
 */
export function experienceHint(eventId: number | null, slug: string | null): string | null {
  for (const [key, xp] of Object.entries(EXPERIENCES)) {
    if (
      (eventId && xp.matches?.eventIds?.includes(eventId)) ||
      (slug && xp.matches?.slugs?.includes(slug))
    )
      return key;
  }
  try {
    const seen = localStorage.getItem(HINT_KEY + (slug || eventId));
    return seen && EXPERIENCES[seen] ? seen : null;
  } catch {
    return null;
  }
}

/** Remember the experience an event wore, for the next visit's skeleton. */
export function rememberExperience(eventId: number, slug: string | null, key: string | null) {
  try {
    for (const k of [slug, String(eventId)].filter(Boolean) as string[]) {
      if (key) localStorage.setItem(HINT_KEY + k, key);
      else localStorage.removeItem(HINT_KEY + k);
    }
  } catch {
    /* storage blocked: the stock skeleton next time, nothing worse */
  }
}
